// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"231":"component---src-pages-video-js","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"231":"d946da785ef032538f48","532":"9358739d364dae5d8443","678":"aca174844ffd08e7bcc1","883":"08ad030942851fea14a0"}[chunkId] + ".js";
};